const CloseSvg = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21 1L1 21M21 21L1 1" stroke="white" strokeWidth="1.2" />
    </svg>
  )
}

export default CloseSvg
